import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  ref: "pageRef",
  style: {"position":"relative","display":"flex","flex-direction":"column","flex":"1 1 auto","min-height":"0"}
}
const _hoisted_2 = { class: "spare-part-search-top-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_card_title = _resolveComponent("card-title")!
  const _component_card_header = _resolveComponent("card-header")!
  const _component_search_by_sn = _resolveComponent("search-by-sn")!
  const _component_card_body = _resolveComponent("card-body")!
  const _component_card = _resolveComponent("card")!
  const _component_search_by_part_number = _resolveComponent("search-by-part-number")!
  const _component_browse_spare_part_catalog = _resolveComponent("browse-spare-part-catalog")!
  const _component_search_by_product_model = _resolveComponent("search-by-product-model")!
  const _component_scroll_arrows = _resolveComponent("scroll-arrows")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["text-left", _ctx.isSmallScreen ? 'flex-item-scroll mobile-page-scroll' : 'flex-node-col card-gap'])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_card, { class: "spare-part-search-top-card" }, {
          default: _withCtx(() => [
            _createVNode(_component_card_header, { class: "k-hstack section" }, {
              default: _withCtx(() => [
                _createVNode(_component_card_title, { style: {"font-size":"16px"} }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.localize('IfYouHaveSN')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_card_body, null, {
              default: _withCtx(() => [
                _createVNode(_component_search_by_sn)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_card, { class: "spare-part-search-top-card" }, {
          default: _withCtx(() => [
            _createVNode(_component_card_header, { class: "k-hstack section" }, {
              default: _withCtx(() => [
                _createVNode(_component_card_title, { style: {"font-size":"16px"} }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.localize('IfYouHavePartNumber')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_card_body, null, {
              default: _withCtx(() => [
                _createVNode(_component_search_by_part_number)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_card, { class: "spare-part-search-top-card" }, {
          default: _withCtx(() => [
            _createVNode(_component_card_header, { class: "k-hstack section" }, {
              default: _withCtx(() => [
                _createVNode(_component_card_title, { style: {"font-size":"16px"} }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.localize('IfYouWantToSeeAllSpareParts')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_card_body, null, {
              default: _withCtx(() => [
                _createVNode(_component_browse_spare_part_catalog)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_card, {
        ref: "modelCardRef",
        class: _normalizeClass([_ctx.isSmallScreen ? '' : 'flex-node-col', 'model-search-card'])
      }, {
        default: _withCtx(() => [
          _createVNode(_component_card_header, { class: "k-hstack section" }, {
            default: _withCtx(() => [
              _createVNode(_component_card_title, { style: {"font-size":"16px"} }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.localize('IfYouHaveNoSN')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_card_body, {
            class: _normalizeClass(!_ctx.isSmallScreen ? 'flex-item-scroll' : ''),
            style: {"padding":"10px 10px 15px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_search_by_product_model)
            ]),
            _: 1
          }, 8, ["class"]),
          (!_ctx.isSmallScreen)
            ? (_openBlock(), _createBlock(_component_scroll_arrows, {
                key: 0,
                "container-ref": _ctx.modelCardRef,
                "scroll-selector": ".k-card-body"
              }, null, 8, ["container-ref"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["class"])
    ], 2),
    (_ctx.isSmallScreen)
      ? (_openBlock(), _createBlock(_component_scroll_arrows, {
          key: 0,
          "container-ref": _ctx.pageRef,
          "scroll-selector": ".mobile-page-scroll"
        }, null, 8, ["container-ref"]))
      : _createCommentVNode("", true)
  ], 512))
}